
import React, { useRef } from 'react';
import { Textarea } from '@/components/ui/textarea';
import { FormControl } from '@/components/ui/form';
import DynamicFieldSelector from './DynamicFieldSelector';

interface TextareaWithDynamicFieldsProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  rows?: number;
}

const TextareaWithDynamicFields: React.FC<TextareaWithDynamicFieldsProps> = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  className,
  rows = 3,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleFieldSelect = (field: string) => {
    if (textareaRef.current) {
      const textarea = textareaRef.current;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      
      // Insert the field at cursor position
      const newValue = value.substring(0, start) + field + value.substring(end);
      onChange(newValue);
      
      // Set cursor position after the inserted field
      setTimeout(() => {
        textarea.focus();
        textarea.setSelectionRange(start + field.length, start + field.length);
      }, 0);
    } else {
      // If no textarea ref, just append to the end
      onChange(value + field);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex justify-end">
        <DynamicFieldSelector 
          onFieldSelect={handleFieldSelect} 
          disabled={disabled}
        />
      </div>
      <FormControl>
        <Textarea
          ref={textareaRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={className}
          rows={rows}
        />
      </FormControl>
    </div>
  );
};

export default TextareaWithDynamicFields;
